import React from "react";
import { Link } from "react-router-dom";

function ListItems({ data, columns, operationLink }) {
  return (
    <>
      {data?.map((item) => (
        <tr key={item.id}>
          {columns.map((column) => (
            <td key={column.id}>
              {column.id === "action" ? ( // Ha az oszlop "action", akkor a szerkesztés linket jelenítjük meg
                <ul className="d-flex justify-content-center action">
                  <li className="edit">
                    <Link to={`/${operationLink}/${item.id}`}>
                      <i className="icon-pencil-alt"></i>
                    </Link>
                  </li>
                </ul>
              ) : column.id === "code" ? (
                // Ha a "code" oszlop, akkor a companyLocation tömböt jelenítjük meg
                item.companyLocation?.map((location) => (
                  <div key={location.id}>
                    <div>
                      <strong>{location.location} - </strong>
                      <span>
                        telep létrehozás dátuma -{" "}
                        {location.companyLocationCreatedAt}
                      </span>
                    </div>
                  </div>
                ))
              ) : column.id === "fullNames" && Array.isArray(item.fullNames) ? (
                // Ha a "fullNames" oszlop, és tömböt kapunk
                item.fullNames
                  .map(
                    (user) =>
                      `${user.fullName + " - " || "-"} ${
                        user.role ? user.role : "-"
                      }`
                  )
                  .join(", ")
              ) : (
                // Az adatokat dinamikusan kérjük le a column.id alapján
                item[column.id] || "-" // Ha nincs adat, akkor "-" jelenik meg
              )}
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}

export default ListItems;
